import { render, staticRenderFns } from "./WineListYourPrices.vue?vue&type=template&id=c8c21a6c&"
import script from "./WineListYourPrices.vue?vue&type=script&lang=js&"
export * from "./WineListYourPrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports